export class ProcCostModel {
    intCodeNo: number
    intCodeType: number
    strStatus: string
    getProcCost: number
    intClinicNo: number
    lngPetNo: number

    constructor(
        intCodeNo: number,
        intCodeType: number,
        strStatus: string,
        getProcCost: number,
        intClinicNo: number,
        lngPetNo: number
    ) {
        this.intCodeNo = intCodeNo
        this.intCodeType = intCodeType
        this.strStatus = strStatus
        this.getProcCost = getProcCost
        this.intClinicNo = intClinicNo
        this.lngPetNo = lngPetNo
    }
}